<template>
  <div class="thumbs-item-container">
    <div class="title">{{ info.name }}</div>
    <div class="summary">{{ info.summary }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {

    };
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  watch: {},
  beforeDestroy() { },
  mounted() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>